(function(){
  const ENABLE_PIXEL   = true;
  const CAPI_ENDPOINT  = 'https://lejuste.app.n8n.cloud/webhook/lead-attempt';

  function qp(n){ return new URLSearchParams(location.search).get(n) || '' }
  function rc(n){ return (document.cookie.match('(^|;)\\s*'+n+'\\s*=\\s*([^;]+)')||[])[2]||'' }
  
  function setCookie(name, value, days){
    const d = new Date(); d.setTime(d.getTime()+days*864e5);
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    
    // Mejor manejo de subdominios para Shopify
    let domain = '';
    if (location.hostname.includes('.')) {
      const parts = location.hostname.split('.');
      if (parts.length >= 2) {
        domain = '; Domain=.' + parts.slice(-2).join('.');
      }
    }
    
    document.cookie = name+'='+value+'; expires='+d.toUTCString()+'; path=/; SameSite=Lax'+secure+domain;
  }
  
  function uid(){
    try{
      if (crypto && crypto.getRandomValues){
        const a = new Uint32Array(1); crypto.getRandomValues(a);
        return a[0].toString(36);
      }
    }catch(e){}
    return (Math.random()*1e9>>>0).toString(36);
  }
  
  function validateEmail(email){
    if (!email || typeof email !== 'string') return '';
    const x = email.trim().toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(x) ? x : '';
  }

  function ensureFbp(){
    let fbp = rc('_fbp');
    if (!fbp){
      // CAMBIO: Usar milisegundos en lugar de segundos
      const ts = Date.now();
      fbp = `fb.1.${ts}.${uid()}`;
      setCookie('_fbp', fbp, 90);
    }
    return fbp;
  }
  
  function buildFbc(){
    // 1. PRIORIDAD MÁXIMA: Buscar fbclid en URL (más fresco y confiable)
    let fbclid = qp('fbclid');
    
    // También buscar en parámetros específicos de Shopify
    if (!fbclid) {
      fbclid = qp('_fbp') || qp('fbp');
    }
    
    if (fbclid){
      // CAMBIO: Usar milisegundos en lugar de segundos
      const ts = Date.now();
      const fbc = `fb.1.${ts}.${fbclid}`;
      setCookie('_fbc', fbc, 90);
      console.log('[FBC] Created NEW from URL fbclid:', fbc);
      return fbc;
    }

    // 2. Si no hay fbclid nuevo, usar cookie _fbc existente
    let fbc = rc('_fbc');
    if (fbc) {
      console.log('[FBC] Using existing _fbc cookie:', fbc);
      return fbc;
    }

    // 3. Buscar en sessionStorage (backup de sesión actual)
    try{
      const sFbclid = sessionStorage.getItem('fbclid');
      const sTs     = sessionStorage.getItem('fbclid_timestamp');
      if (sFbclid && sTs){
        // CAMBIO: El timestamp ya debe estar en milisegundos
        fbc = `fb.1.${sTs}.${sFbclid}`;
        setCookie('_fbc', fbc, 90);
        console.log('[FBC] Restored from sessionStorage:', fbc);
        return fbc;
      }
    }catch(e){
      console.warn('[FBC] sessionStorage not accessible:', e);
    }
    
    // 4. Finalmente buscar en cookies custom (último recurso)
    const cFbclid = rc('_custom_fbclid');
    const cTs     = rc('_custom_fbclid_ts');
    if (cFbclid && cTs){
      // CAMBIO: El timestamp ya debe estar en milisegundos
      fbc = `fb.1.${cTs}.${cFbclid}`;
      setCookie('_fbc', fbc, 90);
      console.log('[FBC] Restored from custom cookies:', fbc);
      return fbc;
    }
    
    console.log('[FBC] No fbclid found in any source');
    return '';
  }
  
  // Mejorada función para persistir fbclid
  (function persistFbclid(){
    let fbclid = qp('fbclid');
    
    // También verificar parámetros de Shopify
    if (!fbclid) {
      fbclid = qp('_fbp') || qp('fbp');
    }
    
    if (!fbclid) {
      console.log('[FBC] No fbclid parameter found in URL');
      return;
    }
    
    // CAMBIO: Usar milisegundos en lugar de segundos
    const ts = Date.now();
    console.log('[FBC] Persisting fbclid:', fbclid, 'with timestamp (ms):', ts);
    
    // Guardar en sessionStorage
    try{
      sessionStorage.setItem('fbclid', fbclid);
      sessionStorage.setItem('fbclid_timestamp', ts);
      console.log('[FBC] Saved to sessionStorage');
    }catch(e){
      console.warn('[FBC] Could not save to sessionStorage:', e);
    }
    
    // Guardar en cookies custom como backup
    setCookie('_custom_fbclid', fbclid, 90);
    setCookie('_custom_fbclid_ts', ts, 90);
    console.log('[FBC] Saved to custom cookies');
    
    // Crear inmediatamente la cookie _fbc si no existe
    if (!rc('_fbc')) {
      const fbc = `fb.1.${ts}.${fbclid}`;
      setCookie('_fbc', fbc, 90);
      console.log('[FBC] Created _fbc cookie immediately:', fbc);
    }
  })();

  function isFbqAvailable(){ return typeof window.fbq === 'function'; }
  function isGtagAvailable(){ return typeof window.gtag === 'function'; }

  function postLead(url, payload){
    const data = JSON.stringify(payload);
    fetch(url + '?t=' + Date.now(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: data,
      keepalive: true
    })
    .then(res => {
      console.log('[Lead->n8n] fetch status:', res.status);
      if (!res.ok) {
        console.warn('[Lead->n8n] HTTP error:', res.status, res.statusText);
      }
    })
    .catch(err => {
      console.warn('[Lead->n8n] fetch error, trying beacon fallback', err);
      try{
        if ('sendBeacon' in navigator){
          const ok = navigator.sendBeacon(url, new Blob([data], {type:'application/json'}));
          console.log('[Lead->n8n] beacon fallback:', ok ? 'enqueued' : 'failed');
        }
      }catch(e){
        console.error('[Lead->n8n] beacon exception', e);
      }
    });
  }

  // Debug inicial para verificar el estado
  console.log('[KLAVIYO DEBUG] Script loaded');
  console.log('[FBC DEBUG] Current URL:', location.href);
  console.log('[FBC DEBUG] Has fbclid in URL:', !!qp('fbclid'));
  console.log('[FBC DEBUG] Existing _fbp:', rc('_fbp'));
  console.log('[FBC DEBUG] Existing _fbc:', rc('_fbc'));

  window.addEventListener('klaviyoForms', function(e){
    if (!e || e.detail?.type !== 'submit') return;

    const md       = e.detail.metaData || {};
    const rawEmail = md['$email'] || md['email'] || e.detail.email || '';
    const email    = validateEmail(rawEmail) || '';
    
    if (!email) {
      console.warn('[Klaviyo Lead] Email inválido/faltante:', rawEmail);
    }

    const eventId  = 'klaviyo_'+(e.detail.formId || 'unknown')+'_'+Date.now()+'_'+uid();
    const fbp      = ensureFbp();
    const fbc      = buildFbc();

    // Debug de valores importantes
    console.log('[Klaviyo Lead] Tracking data:', {
      eventId,
      email: email || 'MISSING',
      fbp: fbp || 'MISSING',
      fbc: fbc || 'MISSING',
      hasValidFbc: !!fbc,
      formId: e.detail.formId
    });

    const payload = {
      event_name: 'Lead',
      event_id : eventId,
      email, fbp, fbc,
      page_url  : location.href,
      user_agent: navigator.userAgent,
      ts        : Math.floor(Date.now()/1000),
      formId   : e.detail.formId || '',
      companyId: e.detail.companyId || '',
      source   : 'klaviyo_form',
      body     : {
        email,
        texto    : md.texto ?? md['texto'] ?? '',
        deseo    : md.deseo ?? md['deseo'] ?? '',
        lifestyle: md.lifestyle ?? md['lifestyle'] ?? ''
      }
    };

    console.log('[Klaviyo Lead] Full payload:', payload);

    // Enviar al webhook
    postLead(CAPI_ENDPOINT, payload);

    // Meta Pixel tracking
    if (ENABLE_PIXEL && isFbqAvailable()){
      try{
        fbq('track', 'Lead', {}, { eventID: eventId });
        console.log('[Meta Pixel] Lead event sent with ID:', eventId);
      }catch(err){
        console.error('[Meta Pixel] Tracking failed:', err);
      }
    } else if (ENABLE_PIXEL){
      console.warn('[Meta Pixel] Requested but fbq not available');
    }

    // Google Ads tracking
    if (isGtagAvailable()){
      try{
        gtag('event', 'conversion', {
          send_to: 'AW-17067611900/BlE_CKnXvtkaEPytvMo_',
          transaction_id: eventId,
          user_data: { email_address: email || undefined }
        });
        console.log('[Google Ads] Conversion sent with ID:', eventId);
      }catch(err){
        console.error('[Google Ads] Tracking failed:', err);
      }
    }
  });

  // Debug adicional para testear manualmente - ACTUALIZADO
  window.debugFBC = function(){
    console.log('=== FBC DEBUG INFO ===');
    console.log('URL fbclid:', qp('fbclid'));
    console.log('URL _fbp:', qp('_fbp'));
    console.log('URL fbp:', qp('fbp'));
    console.log('Cookie _fbp:', rc('_fbp'));
    console.log('Cookie _fbc:', rc('_fbc'));
    console.log('Cookie _custom_fbclid:', rc('_custom_fbclid'));
    
    try {
      console.log('SessionStorage fbclid:', sessionStorage.getItem('fbclid'));
      console.log('SessionStorage timestamp:', sessionStorage.getItem('fbclid_timestamp'));
    } catch(e) {
      console.log('SessionStorage not accessible');
    }
    
    const currentFbc = buildFbc();
    const currentFbp = ensureFbp();
    
    console.log('Current FBC:', currentFbc);
    console.log('Current FBP:', currentFbp);
    
    // Mostrar timestamps decodificados para verificar formato
    if (currentFbc) {
      const fbcParts = currentFbc.split('.');
      if (fbcParts.length >= 3) {
        const timestamp = fbcParts[2];
        const date = new Date(parseInt(timestamp));
        console.log('FBC timestamp decoded:', timestamp, '-> Date:', date.toISOString());
        console.log('Is timestamp in milliseconds?', timestamp.length === 13);
      }
    }
    
    if (currentFbp) {
      const fbpParts = currentFbp.split('.');
      if (fbpParts.length >= 3) {
        const timestamp = fbpParts[2];
        const date = new Date(parseInt(timestamp));
        console.log('FBP timestamp decoded:', timestamp, '-> Date:', date.toISOString());
        console.log('Is timestamp in milliseconds?', timestamp.length === 13);
      }
    }
    
    console.log('===================');
  };

  console.log('[FBC DEBUG] Use window.debugFBC() to check tracking status');
})();